import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../../../../_helpers/components/Button";
import { getProject } from "../../../../../_api/Project";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";

export const Project = () => {
    const navigate = useNavigate();
    const { project_id } = useParams();

    const [project, setProject] = useState(null);

    const loadProject = () => {
        getProject(project_id).then((resp) => {
            setProject(resp.data.data);
        });
    };

    useEffect(() => {
        loadProject();
    }, []);

    return (
        <div className="max-w-7xl mx-auto p-4 space-y-6">
            {/* Header */}
            <div className="flex justify-between items-center">
                <h1 className="text-3xl font-bold text-gray-800">
                    {project ? `Projet : ${project.name}` : "Chargement..."}
                </h1>
                <div className="flex gap-2">
                    <Button
                        type="empty"
                        action={() => navigate(-1)}
                        name="Retour"
                    />
                    <Button
                        action={() => navigate(`/project/form/${project_id}`)}
                        name="Éditer"
                    />
                </div>
            </div>

            {project && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Infos projet */}
                    <div className="bg-white shadow-sm rounded-xl p-6">
                        <h2 className="text-xl font-semibold text-gray-700 mb-2">
                            Informations
                        </h2>
                        <p className="text-gray-600">
                            <strong>Créé le :</strong> {project.created_at}
                        </p>
                        <p className="text-gray-600 mb-4">
                            <strong>Dernière mise à jour :</strong>{" "}
                            {project.updated_at}
                        </p>
                        <InputForm
                            name="Notes"
                            type="textarea"
                            value={project.remarks}
                            set={(value) =>
                                setProject({ ...project, remarks: value })
                            }
                            className="appearance-none block w-full bg-gray-100 text-gray-700 border rounded-sm py-2 px-3 leading-tight focus:outline-hidden focus:bg-white focus:border-gray-400"
                        />
                    </div>

                    {/* Participants */}
                    <div className="bg-white shadow-sm rounded-xl p-6">
                        <h2 className="text-xl font-semibold text-gray-700 mb-2">
                            Participants
                        </h2>
                        {project.users && project.users.length > 0 ? (
                            <ul className="list-disc list-inside text-gray-700">
                                {project.users.map((user) => (
                                    <li key={user.id}>
                                        {user.last_name.toUpperCase()}{" "}
                                        {user.first_name}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-gray-500">
                                Aucun participant enregistré.
                            </p>
                        )}
                    </div>
                </div>
            )}

            {/* Cumul des heures */}
            <div className="bg-white shadow-sm rounded-xl p-6">
                <h2 className="text-xl font-semibold text-gray-700 mb-2">
                    Cumul des heures
                </h2>
                <ul className="list-disc list-inside text-gray-700">
                    <li>TODO</li>
                </ul>
            </div>
        </div>
    );
};
